import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Barbados: Country = {
    identifier: "Barbados",
    name: "Barbados",
    countryCode: "BB",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: true,
    flag: "🇧🇧",
    svgPath: "m 307.92775,426.1274 -0.08,0.057 -0.251,-0.114 -0.088,-0.138 -0.011,-0.438 0.155,-0.042 0.291,0.347 0.169,0.126 z",
}
